export default {
  color: 'primary',
}